function StartScreen({ numQuestions, dispath }) {
  return (
    <div className="start">
      <h2>Welcome to the Quiz!</h2>
      <h3>
        This quiz features {numQuestions} questions covering topics from
        history, science, and geography to literature. You'll earn points based
        on correct answers, and harder questions are worth more points. Test
        your knowledge across multiple areas and try to reach the highest score
        possible!
      </h3>
      <button className="btn btn-ui" onClick={() => dispath({ type: "start" })}>
        Let's start
      </button>
    </div>
  );
}

export default StartScreen;
